import { Component, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../../Common/Components/breadcrumb/breadcrumb.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { SpinnerComponent } from '../../Common/Components/spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { DataGridComponent } from '../../Common/Components/data-grid/data-grid.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { WebaccountAddEditComponent } from './webaccount-add-edit/webaccount-add-edit.component';
import { FormsModule } from "@angular/forms";
import { ApiService } from '../../Services/api.service';
import { forkJoin, Observable } from 'rxjs';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'app-web-account-manage',
  standalone: true,
  imports: [BreadcrumbComponent,NzIconModule, NzButtonModule, SpinnerComponent,NzInputModule, CommonModule, DataGridComponent, NzRadioModule, WebaccountAddEditComponent, FormsModule],
  templateUrl: './web-account-manage.component.html',
  styleUrl: './web-account-manage.component.scss'
})
export class WebAccountManageComponent {

  constructor(private apiService: ApiService) {

  }
  breadcrumbs: Array<{ label: string, url: any }> = [
  {
    label: "Web Account Management",
    url: ["/webaccount-manage"]
  }
  ];
  isLoading: boolean = false;
  invalidSearch: boolean = false;
  webAccountList: any = [];
  searchType: string = 'UserId';
  searchInput: string = '';
  webAccountColumns: any = [{
    field: 'userId',
    header: '',
    type: "checkbox"
  },
  {
    field: 'arNo',
    header: 'AR',
    compare: (a: any, b: any) => (a.arNo ?? "").localeCompare((b.arNo ?? ""))
  },
  {
    field: 'edpNo',
    header: 'EDP',
    compare: (a: any, b: any) => (a.edpNo ?? "").localeCompare((b.edpNo ?? ""))
  },
  {
    field: 'userId',
    header: 'User Name',
    compare: (a: any, b: any) => (a.userId ?? "").localeCompare((b.userId ?? ""))
  },
  {
    field: 'userType',
    header: 'Type',
    compare: (a: any, b: any) => (a.userType ?? "").localeCompare((b.userType ?? ""))
  },
  {
    field: 'emailId',
    header: 'Email Address',
    compare: (a: any, b: any) => (a.emailId ?? "").localeCompare((b.emailId ?? ""))
  },
  {
    field: '',
    header: 'Action',
    icons: ['edit', 'delete'],
    type: 'icon',
    showIcons: true
  }];

  addEditEnabled: boolean = false;
  selectedUserList: any = [];
  userData: any;
  @ViewChild(WebaccountAddEditComponent) private webAccountAddEditComponent!: WebaccountAddEditComponent;
  @ViewChild(DataGridComponent) private dataGridComponent!: DataGridComponent;
  searchText:string = '';

  searchUser() {
    if (!this.searchInput) {
      this.invalidSearch = true;
    }
    else {
      this.invalidSearch = false;
      this.apiService.getUsersByIdEdpArNo(this.searchInput, this.searchType).subscribe(res => {
        this.webAccountList = res;
        this.webAccountList.map((node:any)=>Object.assign(node,{'pageEdit':true}));
      }, err => {
        this.apiService.createNotification('error', err?.error.message);
        this.webAccountList = [];
      })


    }
  }

  deleteUser(data: any) {
    this.apiService.deleteUserById(data.userName).subscribe(res => {
      this.apiService.createNotification('success', res?.message);
      this.searchUser();
    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  selectedUsers(data: any) {
    this.selectedUserList = [...data];
  }

   searchArNo(searchValue: string) {
    this.dataGridComponent.searchData(searchValue, 'arNo');
  }

  editUser(data: any) {
    this.apiService.getUsersByIdEdpArNo(data.userId, 'UserId').subscribe(res => {
      this.userData = res[0];
      this.addEditEnabled = true;

    }, err => {
      this.apiService.createNotification('error', err?.error.message);
    })
  }

  deleteUsers() {
    const apiCalls$: Observable<any>[] = this.selectedUserList.map((node: any) =>
      this.apiService.deleteUserById(node)
    );

    forkJoin(apiCalls$).subscribe({
      next: (responses: any[]) => {
        this.apiService.createNotification('success', responses[0].message);
        this.searchUser();
      },
      error: (err) => {
        this.apiService.createNotification('error', err?.error?.message);

      },
      complete: () => {
      }
    })
  }

  saveEditAction() {
    this.webAccountAddEditComponent.addUpdateUserForm();
  }

  toggleForm(data:any){
   if(data){
    this.addEditEnabled = false;
    this.userData = {};
   }
  }
}
